import { Outlet } from "react-router-dom";
import { StudentAppShell } from "./StudentAppShell";

export default function StudentLayout() {
  return (
    <StudentAppShell>
      <Outlet />
    </StudentAppShell>
  );
}
